import axios from 'axios';
import React, { useState , useEffect } from 'react';

import { useParams } from 'react-router-dom';

const Redirect = ({ baseURL }) => {
  const { id } = useParams();
  console.log('id',id);
  const [redirectLink, setRedirectLink] = useState('');
  const [status, setStatus] = useState('');

  const handleRun = async () => {
    const res = await axios.get(`${baseURL}/testing/${id}`, {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',         
      },
    });
    console.log('handleRun check',res);
    setRedirectLink(res.data.data);
    setStatus(res.data.status);        
  };

  useEffect(() => {
    if (status === 'success') {
      window.open(redirectLink, '_self');
    }
  },[status]);

  useEffect(() => {
    setTimeout(() => {
      handleRun();
    },0);
  },[id]);
  return (
    <div />
  );
};

export default Redirect;
